/**
 * Parse FastAPI-style error bodies (detail string or validation array).
 */
export function formatApiError(err, fallback = 'Request failed') {
  const detail = err.response?.data?.detail
  if (detail == null) return fallback
  if (typeof detail === 'string') return detail
  if (Array.isArray(detail)) {
    return detail.map((x) => (typeof x === 'object' && x?.msg ? x.msg : String(x))).join(', ')
  }
  return fallback
}
